import * as React from 'react';
import {StatusIndicator, PopoverButton, TscButtonType, TscPopoverOrigin} from '@techsmith/tsc-cloud-style-guide';
import Strings from '../../globals/Strings';
import Themeable from '../../types/Themeable';

export default ({reviewsCount, maxReviewsCount, themeName}: ReviewsCountProps) => {
   const statusMenuText = Strings.statusIndicator.menu.replace('{param0}', reviewsCount.toString()).replace('{param1}', maxReviewsCount.toString());
   const statusMenu = <div className="status-menu">{statusMenuText}</div>;
   const statusIndicator = <StatusIndicator value={reviewsCount} max={maxReviewsCount} style={{width: '6rem', height: '1rem', marginLeft: '.5rem', marginRight: '.375rem'}}/>;
   const popoverButtonStyle = {marginLeft: '.5rem'};

   return (
      <div className="review-count">
         <PopoverButton key={2}
                        style={popoverButtonStyle}
                        buttonGlyph={statusIndicator}
                        popoverMenu={statusMenu}
                        buttonType={TscButtonType.secondary}
                        showArrow={true}
                        themeName={themeName}
                        origin={TscPopoverOrigin.bottomLeft}
                        buttonTitle={Strings.statusIndicator.description.replace('{param0}', reviewsCount.toString()).replace('{param1}', maxReviewsCount.toString())} />
      </div>
   );
};

export interface ReviewsCountProps extends Themeable {
   reviewsCount: number;
   maxReviewsCount: number;
}
